export function filterControlTestId(baseId: string, columnDataKey?: string | number): string {
  if (columnDataKey === undefined || columnDataKey === "") {
    return baseId;
  }
  const safe = String(columnDataKey).replace(/[^a-zA-Z0-9_-]/g, "-");
  return `${baseId}--${safe}`;
}
